"use client";
import { HOSTS } from "../hosts";

const ENV_SELECTOR_OPTIONS = Object.values(HOSTS).map(({ key, name, color, backgroundColor }) => ({
    value: key,
    name,
    style: { backgroundColor, color, fontWeight: "bold" },
}));

export function EnvironmentSelector({ value, onChange, children }) {
    const selectedHost = HOSTS[value];

    return (
        <div style={{ position: "fixed", top: "-8px", right: "-50px", padding: 5, zIndex: 1 }}>
            {children({
                value,
                onChange,
                options: ENV_SELECTOR_OPTIONS,
                color: selectedHost?.color,
                style: { opacity: 1, backgroundColor: selectedHost?.backgroundColor },
                size: "small",
            })}
        </div>
    );
}
